import React, { useState } from 'react';
import { Avatar, Box, Divider, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

export default function AccountMenu() {
    const { t } = useTranslation();
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [anchor, setAnchor] = useState(null);
    const close = () => setAnchor(null);

    return (
        <>
            <Tooltip title={user ? `${user.firstName} ${user.lastName}` : ''}>
                <Avatar onClick={(e) => setAnchor(e.currentTarget)} sx={{
                    width: 34, height: 34, fontSize: 14, fontWeight: 700, cursor: 'pointer', color: '#fff',
                    background: 'linear-gradient(135deg, #4e90b5 0%, #427898 100%)',
                }}>
                    {user?.firstName?.[0]?.toUpperCase() || '?'}
                </Avatar>
            </Tooltip>
            <Menu anchorEl={anchor} open={!!anchor} onClose={close}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  slotProps={{ paper: { sx: { minWidth: 230, borderRadius: 2, mt: 1 } } }}>
                <Box sx={{ px: 2, py: 1 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: 14, color: '#1a2332' }}>{user?.firstName} {user?.lastName}</Typography>
                    <Typography sx={{ fontSize: 12, color: '#94A3B8' }}>{user?.email}</Typography>
                    <Typography sx={{ fontSize: 12, color: '#427898', fontWeight: 600, mt: 0.5 }}>{user?.companyName}</Typography>
                </Box>
                <Divider />
                <MenuItem onClick={() => { close(); navigate('/settings/company'); }} sx={{ fontSize: 13.5 }}>
                    <ListItemIcon sx={{ color: '#427898' }}><ApartmentOutlinedIcon fontSize="small" /></ListItemIcon>
                    {t('nav.company')}
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => { close(); logout(); navigate('/login'); }} sx={{ fontSize: 13.5 }}>
                    <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
                    {t('nav.logout')}
                </MenuItem>
            </Menu>
        </>
    );
}
